// @ts-ignore
import GLightbox from 'glightbox';

export class Lightbox {
    selector: string;
    lightboxes: NodeListOf<HTMLElement>;

    constructor() {
        this.selector = 'data-lightbox-content';
        this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
        this.init();
    }

    init() {
        // @ts-ignore
        this.lightboxes.forEach((lightbox) => {
            const glightbox = GLightbox({
                selector: null,
                skin: 'clean glightbox-content',
                zoomable: false,
                autoplayVideos: false,
                svg: {
                    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>',
                    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
                    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>'
                },
            });

            const elements: NodeListOf<HTMLAnchorElement> = lightbox.querySelectorAll('[' + this.selector + '-item]');
            const promises = [];
            elements.forEach((el) => {
                const index = el.dataset.lightboxContentItem;
                promises[index] = fetch(el.href)
                    .then((response) => {
                        return response.text()
                    })
                    .then((result) => {
                        return result;
                    })
                    .catch((e) => {
                        console.warn('Error on fetch request: ', e)
                    });
                el.addEventListener('click', (event) => {
                    event.preventDefault();
                    glightbox.openAt(index);
                });
            });
            // @ts-ignore
            Promise.allSettled(promises).then((results) => {
                results.forEach((result) => {
                    glightbox.insertSlide({
                        content: result['value'],
                    });
                });
            });

            glightbox.on('slide_after_load', (data) => {
                const { slideIndex, slideNode, slideConfig, player, trigger } = data;
                const shareButton = data.slide.querySelector('[data-lightbox-content-share-button]');
                const shareOverlay = data.slide.querySelector('[data-lightbox-content-share-overlay]');
                if (shareButton && shareOverlay) {
                    shareButton.addEventListener('click', () => {
                        shareOverlay.classList.toggle('is-visible');
                    });
                }
            });
        });
    }
}
document.addEventListener("DOMContentLoaded", function() {
    new Lightbox();
});
